import { Component, HostBinding, afterNextRender, signal } from '@angular/core';
import { NgIf } from '@angular/common';

const EXPO_URL = 'https://www.tstexpo.com/?utm_source=sfsupplies&utm_medium=referral&utm_campaign=fall-2026&utm_content=homepage-banner';
/** The expo runs Nov 18-19, 2026; the banner comes down at the end of the 19th (Eastern). */
const EXPO_ENDS = new Date('2026-11-20T00:00:00-05:00');
const DISMISSED_KEY = 'tst-expo-2026-banner-dismissed';

/** "Register for the TST Expo" strip at the top of the homepage. Self-contained (own
 *  colours, no dev-only tokens) so the same commit sits on both the dev and master
 *  homepages. Takes itself down after the expo; a visitor can close it sooner. */
@Component({
  selector: 'app-tst-expo-banner',
  imports: [NgIf],
  templateUrl: './tst-expo-banner.component.html',
  styleUrl: './tst-expo-banner.component.css'
})
export class TstExpoBannerComponent {
  readonly url = EXPO_URL;

  /** The date check runs on the server too, so the prerendered page carries the banner
   *  until the expo is over. A stale prerender after that only shows HTML the client
   *  drops (an unclaimed view), never the reverse, so hydration stays clean. */
  readonly shown = signal(Date.now() < EXPO_ENDS.getTime());

  constructor() {
    // Read only after hydration: the server cannot see localStorage, so hiding in the
    // first pass would not match the HTML it sent.
    afterNextRender(() => {
      try {
        if (localStorage.getItem(DISMISSED_KEY)) this.shown.set(false);
      } catch { }
    });
  }

  /** Lets the homepage hero make room while the banner is up - see `.teb-on` in styles.css. */
  @HostBinding('class.teb-on') get on() {
    return this.shown();
  }

  dismiss() {
    this.shown.set(false);
    try {
      localStorage.setItem(DISMISSED_KEY, '1');
    } catch { }
  }
}
